module.exports = __webpack_public_path__ + "static/media/logo-and-Nansen-&-Co.38e95189.jpg";